import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './user-info-fields.constant';

const en = {
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email'
};

export type UserInfoFieldsTranslations = typeof en;

@NgModule()
export class UserInfoFieldsTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
